<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
          {
        "num_cand": "U2FsdGVkX1/e+FnTZL+ar9TxAsDamHn1mt4d+xfS5JE=",
        "cpf": "U2FsdGVkX1/I2waJudYgtDp52SdVLOuv1jlGfzgE0tc="
      }, {
        "num_cand": "U2FsdGVkX18Oiltbh+DUJMkcx54BV+KnmAGdfHk7Brc=",
        "cpf": "U2FsdGVkX1+5E5VJEsrtidji5cbLwG3J/58ALV4VxHk="
      }, {
        "num_cand": "U2FsdGVkX1/TJWlkmehZntMQthPSQPkhPOAhlYIbIxg=",
        "cpf": "U2FsdGVkX19nCOPfckTcWqwJ92uR/8pbaMbmUKfSXjo="
      }, {
        "num_cand": "U2FsdGVkX18nP2r5Nmx6JYpzL5b0tf/z6xRv3tqGPpQ=",
        "cpf": "U2FsdGVkX1/r1sUoUXzV9EbXW2Vyb4KR9e4aX1tkk8M="
      }, {
        "num_cand": "U2FsdGVkX1/Wx5lpMOeoflx/5zHjhhXeQUfZ7DA04BI=",
        "cpf": "U2FsdGVkX19jG3PBhdQNwMFe6HxbL9ZFww5ABMZZrTQ="
      }, {
        "num_cand": "U2FsdGVkX18hq/zn1sSZtO9UZ22TLoU1gjeV9wkC8I4=",
        "cpf": "U2FsdGVkX18XWuyVre7nwmgnqiV1o+r1WS1UjEsFB8k="
      }, {
        "num_cand": "U2FsdGVkX19zm91GVQ+llcE0woVKMLAGLzZ1RXKw648=",
        "cpf": "U2FsdGVkX1+r0CWGxPs6N1ZpqNSRXg8JavhqhDRtrsQ="
      }, {
        "num_cand": "U2FsdGVkX19o7niTdcXBJueteJME3GPzPfObugvVUOY=",
        "cpf": "U2FsdGVkX1+gvyfzThldlJrP+Ah7mpmRrzRAxe4Un1Y="
      }, {
        "num_cand": "U2FsdGVkX1/TAmnLm64LG0skHFmOeM8REWk58vXvn+Q=",
        "cpf": "U2FsdGVkX1/w1CLfj34jMw1WcLPQkeyP0Lwbemv6jsA="
      }, {
        "num_cand": "U2FsdGVkX18VW35jgI+CFneTGrFlp5/8Q3c74DIHj4I=",
        "cpf": "U2FsdGVkX1/fJJKDh/0PBslkTxw/vUxBc1PSJWUb1WU="
      }, {
        "num_cand": "U2FsdGVkX18g8M87Xlhf7zQg0txLphoY1KmD1CNgQ10=",
        "cpf": "U2FsdGVkX1/k+s5l2W5jU0BGT+exuqkJCml7yJq0f7c="
      }, {
        "num_cand": "U2FsdGVkX1+KfrL2QP47qPyZB9Ga5sDWnSflud5f5UU=",
        "cpf": "U2FsdGVkX1+947l3e7wMOXduDC7ZMctH3eL7TqQR+YM="
      }, {
        "num_cand": "U2FsdGVkX197+f91zE4STteroWtIwxxyBWKk5fiMGiw=",
        "cpf": "U2FsdGVkX1+rlWlXM9X1V/21PnXorv/f5om7km+SlfY="
      }, {
        "num_cand": "U2FsdGVkX188+rmCKcRNUX55d+WycgPwaNzIqgSl0DE=",
        "cpf": "U2FsdGVkX1/z4dm59XZQArdDMBoIOmM8we2+fo5avWk="
      }, {
        "num_cand": "U2FsdGVkX1+ORQIS4b6sap0a1TmpazOU0E/SPTuCCJI=",
        "cpf": "U2FsdGVkX1++U9We/rN1rx85t1CvRVOccklbhPC07wo="
      }, {
        "num_cand": "U2FsdGVkX1/5N3DteFlDppEW9e7LGZEnb1Tazl/BCaU=",
        "cpf": "U2FsdGVkX19l8m+/ovjQ+WQ2kRPgmWMFcc71GpYPaXk="
      }, {
        "num_cand": "U2FsdGVkX18VTqqLY2emPAVE9D5j8KaUS/FUZv7hjKE=",
        "cpf": "U2FsdGVkX18XDqKKehvHYfN3c0PZCKxMDIeD8aMgNd8="
      }, {
        "num_cand": "U2FsdGVkX1/Js9hHtKQ9NlYu5rmvKv8auArvGNvpjYQ=",
        "cpf": "U2FsdGVkX19YOBA7dEbr2CgCQqz3i8OU0J0R0/m3n6o="
      }, {
        "num_cand": "U2FsdGVkX1/uZbOAzHnnzp96lRT8e91xGcL0h0c3L0Q=",
        "cpf": "U2FsdGVkX1+JBa5rECOl/+YS5Oa1+dLcDLUf1t6gJeU="
      }, {
        "num_cand": "U2FsdGVkX18kDTxSG6PHFG5zbz41ARtWz1lXNzR1ybA=",
        "cpf": "U2FsdGVkX19IuipWN65kMK7oQqzsKNW3hCvCVcIRmZE="
      }, {
        "num_cand": "U2FsdGVkX1/M5aggIEC2IleIbUb7MmEhJbYS8eZVmSY=",
        "cpf": "U2FsdGVkX1+r9DwkrHpX5y0+9LVuGDz0KDuZDO1Lq/A="
      }, {
        "num_cand": "U2FsdGVkX1/9Sypvq2hD1645ClYU8Y0XKfCHchl5ABM=",
        "cpf": "U2FsdGVkX194Szi1qlcPFOLvCpW3cmHc1mXAo388jng="
      }, {
        "num_cand": "U2FsdGVkX1+Rqo/dgawuKfiSmCByqi4z0COdu1VnBao=",
        "cpf": "U2FsdGVkX18QdolbxvDxh+l1rEnqhc0y5Rb4hT5/FWU="
      }, {
        "num_cand": "U2FsdGVkX18yMdNkvWV2SZX7CTsXxd8QTIbpCDNYPfg=",
        "cpf": "U2FsdGVkX1+dYxLrb8ItyNkaJ174Haxxd85bnBYuohY="
      }, {
        "num_cand": "U2FsdGVkX1/fA/AsWRV0zfbb4LpKacSq5A1czUN5B9Q=",
        "cpf": "U2FsdGVkX1/U7EepwfcJwEZGc8hfLz7Topd+f1/iY48="
      }, {
        "num_cand": "U2FsdGVkX1/w/JR7Xn2TSoniF7LvelUs82g3r/WpdCA=",
        "cpf": "U2FsdGVkX19FX0dRexCdgxOxBdQYmAt53lfeMgatqp8="
      }, {
        "num_cand": "U2FsdGVkX1+YDpxdDjXz489VJJZauL8dZ1kIlD7DnAQ=",
        "cpf": "U2FsdGVkX18tsl5YsvhAZps5GhbHJKFCze0viVtb5cM="
      }, {
        "num_cand": "U2FsdGVkX19AnMys64QGO2DDN5AdNtFjzZRGoRDIqUs=",
        "cpf": "U2FsdGVkX1/3gOOBppz7vEyy2FabkfND6SCT4MVHX+8="
      }, {
        "num_cand": "U2FsdGVkX1+sddvj3slm2ujTthnzIWkuECnmK/AtusE=",
        "cpf": "U2FsdGVkX1/FrQqEyxfzOobHBH/Orn9IR9XAtkTel44="
      }, {
        "num_cand": "U2FsdGVkX1/Hisvr/yv2vOSAIhZLl0DO71hegGT5uVQ=",
        "cpf": "U2FsdGVkX18YeyMFq3p6fteAu89H4PlpBl7xA4Bvxow="
      }, {
        "num_cand": "U2FsdGVkX19VsQt6LWSlBmVRKXL1Uts4O9fwXTyLY7o=",
        "cpf": "U2FsdGVkX181dLgZTSYQRsVsWZ408nvakk6Rcn/I3S8="
      }, {
        "num_cand": "U2FsdGVkX1/Og7pj5Vgddr1njCWdk2MieHPtwfl3I0I=",
        "cpf": "U2FsdGVkX18Q7PtY1Xfdt73m/3VJFKyLyDrCyHKW7Qg="
      }, {
        "num_cand": "U2FsdGVkX198JqOddnDgQs3K7EcP1vfgkKVJPVZsgS4=",
        "cpf": "U2FsdGVkX18S9QPCqO8seyR6CaFQ1oxv1Ot6D5FK4e0="
      }, {
        "num_cand": "U2FsdGVkX1+B4p3cfYbDvt/vJLvxAAulsVv2ZVk1D4E=",
        "cpf": "U2FsdGVkX1+t8d10vAipnfmNaYuqC9lYJKn19dQlEHs="
      }, {
        "num_cand": "U2FsdGVkX1+kRO2QRXhkxEOHUAEQ9MKqSO2ebl5Cf+w=",
        "cpf": "U2FsdGVkX1+FOQQCNe1pi4MUoz4TH2ayrUmFLsgkxro="
      }, {
        "num_cand": "U2FsdGVkX1/G9TPnuI+Vn+Bma/JqbPnxq//otgGeeYw=",
        "cpf": "U2FsdGVkX19DWvu001oUw0Pw8pdQo+zO0yRjTM9CQuY="
      }, {
        "num_cand": "U2FsdGVkX192wq/DOYNYHMgIlOQGU/D4cH+ugil8PKc=",
        "cpf": "U2FsdGVkX1/MhrlKMnd0W/HBvw0kwDdZIjH1ZUlsA1w="
      }, {
        "num_cand": "U2FsdGVkX19f44L/QHmNUfULtE4c3Rnb5aeV9sxAwx8=",
        "cpf": "U2FsdGVkX189zyVk1VSlnvpweYrjrsHxwCwSMByloLQ="
      }, {
        "num_cand": "U2FsdGVkX1/Y55Sug7lMSy6/WcR5wnx+aauMexIDR70=",
        "cpf": "U2FsdGVkX19nB3tLgZYJCwUhJdkYdGwFHqtH2zI/Ges="
      }, {
        "num_cand": "U2FsdGVkX18Q4q//XN74jLXOkbpX8oqbZ7jmCgTwrGQ=",
        "cpf": "U2FsdGVkX19XXzIVQvyuNqsadXtNr8876a1CN2jEY4s="
      }, {
        "num_cand": "U2FsdGVkX1/NNKGsOb0thDUauqy/rTyeiWsLAtqB3cA=",
        "cpf": "U2FsdGVkX1+p0qLq+FAATwXMS5DLe01ca4VCkj4UtSg="
      }, {
        "num_cand": "U2FsdGVkX18MBCZ3/uG5szXlv5skxPyQ5/gK8UiS6pA=",
        "cpf": "U2FsdGVkX19+YgkqF/Ox8H80zflcjeloXVMKZBwyHhE="
      }, {
        "num_cand": "U2FsdGVkX18yDWWbb1pIYxdDsRbWaoKY+f+gWc7S6yo=",
        "cpf": "U2FsdGVkX19AsBz4EOhfcs+iJES1z89dU5Ar9JV6Lno="
      }, {
        "num_cand": "U2FsdGVkX190GuCZjdyRDiS4gGe7QajU7vGCWep8MKA=",
        "cpf": "U2FsdGVkX1/KNu75pkGKFXxMOYC9OCBOI9UtB/FHUbQ="
      }, {
        "num_cand": "U2FsdGVkX1+udID7DjU4Vi8DOQ5yUUeB5Yc8r4bFVmk=",
        "cpf": "U2FsdGVkX1+07iIJYKnQq+w0F4jgeMVWu2MJdq0KOak="
      }, {
        "num_cand": "U2FsdGVkX1/bhM12XS/tr6HWbpzksgra+de4olT4yrE=",
        "cpf": "U2FsdGVkX1/1738vcAOywXt2aKD/ALB6EWly9wmYgMc="
      }, {
        "num_cand": "U2FsdGVkX1+HxxYLAFmUeiQLrHq+O0v7ekdtjL3x4rQ=",
        "cpf": "U2FsdGVkX180070bgbaCZNpqjeB+Mz8lmVAIhxXw594="
      }, {
        "num_cand": "U2FsdGVkX18g18JKwTkoiiSqi1O+XRzVrP7JvGbUfyo=",
        "cpf": "U2FsdGVkX18pmgmJQ2Ekmg6Ex2nzZwv1aobE7nfBVWg="
      }, {
        "num_cand": "U2FsdGVkX19ckeVwEeVVxrAV9c5xFtyvBS9dJARxGbg=",
        "cpf": "U2FsdGVkX18p5zvxgj34TaZ75oR0a6AqcLRQ/dFYMM4="
      }, {
        "num_cand": "U2FsdGVkX19Hc96XUAOTu/EXxq6Ays6l/PyCOm1j4so=",
        "cpf": "U2FsdGVkX1+oPK8aF+ZMBZuonT/xqVIxefRcy+5VL+M="
      }, {
        "num_cand": "U2FsdGVkX18GmxPB4ynoVS4wTTfK8CCunhXujzOAe/E=",
        "cpf": "U2FsdGVkX1+W4ALsmNLxh7iY69z90H21ZkhPXa77DGo="
      }, {
        "num_cand": "U2FsdGVkX18mrEsvmxijiaJ2rSKjJIKKEuok2Rkcdg0=",
        "cpf": "U2FsdGVkX18OLSdxEz+EbuM2WJTU8G+Yje/jHpTgaMk="
      }, {
        "num_cand": "U2FsdGVkX1/ATGoraGTOQsRdwA7yDfWd3cChgnhzFa8=",
        "cpf": "U2FsdGVkX19iPH+1VXrCWLL7JIUnAOxZ7KCiGq6OZt4="
      }, {
        "num_cand": "U2FsdGVkX1/ZboxZOz2VdaL+vuK4hz9EgBACEU6yBPs=",
        "cpf": "U2FsdGVkX1+815R00MRiwPw3498Y2YAaJVOFNQiLsCI="
      }, {
        "num_cand": "U2FsdGVkX1+9ksOxy+3AhiUvkCv863VnqOYIOq3XJLo=",
        "cpf": "U2FsdGVkX18xUe484/L9siQwoaHjvivYKRCoLsLUric="
      }, {
        "num_cand": "U2FsdGVkX1+ULLcMbhF4cCmdbs89aKdvyawsLxOPRoM=",
        "cpf": "U2FsdGVkX18rYcZPSGNvvCRomQfG49BXVRgX22g5F1g="
      }, {
        "num_cand": "U2FsdGVkX18ScQvSmcSUpxemkyJweP90SflJOLg4br0=",
        "cpf": "U2FsdGVkX19HZWpMa8Fg0JsKwWpUhVNlqBByKqvmVKk="
      }, {
        "num_cand": "U2FsdGVkX1/R9H6/lWsqL3x6ELcpFHGIKqoLayuzo84=",
        "cpf": "U2FsdGVkX1/zW8OBy8DtSH2eRGA9hN3EvC8QUAvz9k8="
      }, {
        "num_cand": "U2FsdGVkX188cFdGZJJkbI5HRw9nUHtRCvztCysM7vc=",
        "cpf": "U2FsdGVkX19tntDiyG9xKzDYfpuOTR5TAiCYlAsb0Xs="
      }, {
        "num_cand": "U2FsdGVkX18huxgYprNS2xaKPoByzxELaRtis8IUj7I=",
        "cpf": "U2FsdGVkX19U4lsxn0ugHYmBFbipkKmatVwprDFLJq4="
      }, {
        "num_cand": "U2FsdGVkX190Ood0d3EWiJmE7dEvx7TLIoNK78xJvJI=",
        "cpf": "U2FsdGVkX1+vFpNTFSBIOyghFRzq2QjUtD5fnxF08Vw="
      }, {
        "num_cand": "U2FsdGVkX1+HpiskODlaL3JuLdFPYeWMV57Wa5GuUhY=",
        "cpf": "U2FsdGVkX19PE8BJCCzBlqTgh2yQMBbWvF88nZ4dywk="
      }, {
        "num_cand": "U2FsdGVkX1/1RxpZuFnnBfxfFmBxJ/o0obrWMCg53Lw=",
        "cpf": "U2FsdGVkX1+lrqOraDRBuznZkyPRHal4Ugf4TyTZbwU="
      }, {
        "num_cand": "U2FsdGVkX1+b7+lej08tuDj7KXkCHc0Jj6nrtPI/Fwg=",
        "cpf": "U2FsdGVkX197e/ZVQkGmHycdWOtf2pX1enqt4ECS5GA="
      }, {
        "num_cand": "U2FsdGVkX1/WQPN6kLepxP9i+Ht5g1RURIj3RbszZMM=",
        "cpf": "U2FsdGVkX1+/3EputVWNd6fftcZsUiAoW7cm5ABeaIY="
      }, {
        "num_cand": "U2FsdGVkX19/7VT5D+EUNhh8W9T3eODalrddd7N/V5M=",
        "cpf": "U2FsdGVkX18sij2OGcgTFLfciGsOCXkVLzOXPVgJay8="
      }, {
        "num_cand": "U2FsdGVkX18Vmt7gAurSj40/nuR6DNS+dEnfQf9wxWE=",
        "cpf": "U2FsdGVkX18rcvjz4FKhF6MQoQ7apnfT0mJraCTj8I0="
      }, {
        "num_cand": "U2FsdGVkX18aDQxIJPuUcI/PH2y8/eA9FqJNC3OJXQc=",
        "cpf": "U2FsdGVkX1/IQXIxItAGFw/eqrwthj/oJUVC6paQul8="
      }, {
        "num_cand": "U2FsdGVkX1+Fws+DnXaQwgsH10QREXs7txsx7jInLhs=",
        "cpf": "U2FsdGVkX19X2WCLWI9HY23qweK9OnRcRrHCKWwc65o="
      }, {
        "num_cand": "U2FsdGVkX18jhsZgoce9unKAaQWRpjHHfM+6ETdsgTA=",
        "cpf": "U2FsdGVkX1+sR0bmQ22sYmNqsmpzFzvJnbQLwbEGshk="
      }, {
        "num_cand": "U2FsdGVkX19XzEzd+tOZNsTrivrnrV+zbeFP1UbUbq8=",
        "cpf": "U2FsdGVkX1+nobnWzsummJ4ZLBVNDPhQae2bMh3DOhU="
      }, {
        "num_cand": "U2FsdGVkX1+ZenOWVdl6b6yDJvCM/a0A/7bgBuZqHMQ=",
        "cpf": "U2FsdGVkX1/Kl5qQvlOVOuihItPEem6RyGAa9UGatYI="
      }, {
        "num_cand": "U2FsdGVkX1/PW0jytsxeIqUHHxOCT9zThpp4DSx0vuQ=",
        "cpf": "U2FsdGVkX1+ujnG/OqPXP2P1uCLLclpHT+9OMkWMLjk="
      }, {
        "num_cand": "U2FsdGVkX1+ZidK9+u5+e6BY07sMyTuYMwqGHmCIiGo=",
        "cpf": "U2FsdGVkX1/vUbPASJJA37eiWEwth0qZgDUqBfW/Lxo="
      }, {
        "num_cand": "U2FsdGVkX19u+POMaMUmObtO7bH7a7IQwCWLUrLVLHI=",
        "cpf": "U2FsdGVkX1+hwKhIv4Z5kfu1IDPtBC5y0sErgNVYuxg="
      }, {
        "num_cand": "U2FsdGVkX18YBHib+d4J3xNmitnTbIJ3h3gEIVyRgQ4=",
        "cpf": "U2FsdGVkX18HRHdGxUuJJB9x8tnZk6am3GeH8FCC2iM="
      }, {
        "num_cand": "U2FsdGVkX1/9mc+VVLDVZ1mssYVvXFkunixgzwX5lt0=",
        "cpf": "U2FsdGVkX1/WQ3478uMjTdaOtVjS2CyP/AvWIORW7ew="
      }, {
        "num_cand": "U2FsdGVkX1+35kyCSc8ik5W8H8YfZlcbyLOwMMzzL/w=",
        "cpf": "U2FsdGVkX18i5TlN8k7/rBT/eXv3wvS47eCMPFVLpI0="
      }, {
        "num_cand": "U2FsdGVkX1/xvrwtgiL5Ni+jsuMPTK7KfKIIf3ns5Z0=",
        "cpf": "U2FsdGVkX1+HRphtKscQYpxzUb/29m32yq8Z+FSgiYU="
      }, {
        "num_cand": "U2FsdGVkX1+mNkG9o6hdviuhXJ//ZMmYYIGEJHCINKI=",
        "cpf": "U2FsdGVkX1/uOUvVMLn+TpSuWLOAm1/8FqMuV5Ib4x0="
      }, {
        "num_cand": "U2FsdGVkX1/KJQdBGNDwyzABvErS4iqNGnH/aOuHgag=",
        "cpf": "U2FsdGVkX19xVQ0b6pm+cvbIs/rtFM3KVuz74aNAE7w="
      }, {
        "num_cand": "U2FsdGVkX19sOV5U1/Y/+37wWcWrytEgr5xbnLkiUlo=",
        "cpf": "U2FsdGVkX18rcOz8+N7pJd2Ogfr4an256uIA8l67ies="
      }, {
        "num_cand": "U2FsdGVkX1/e4xKOExe8BmjDxfaEjlqZd7E88HC/MRk=",
        "cpf": "U2FsdGVkX19LLXn0U21YtDsbfUvuSKpgsW6+2Xktzyk="
      }, {
        "num_cand": "U2FsdGVkX1/mytsbRGGnZdlRECQjCv/mynOR+ojJwGs=",
        "cpf": "U2FsdGVkX19Qmqy1ezcAT77y+7kHdtynJI8c9yZSOFY="
      }, {
        "num_cand": "U2FsdGVkX1+qzGvD0w597Sx3MxR4ah3cjCdbL9+SfEg=",
        "cpf": "U2FsdGVkX18qkU+fG5B0PQvahnIzGSHaWtWR+wFpvAw="
      }, {
        "num_cand": "U2FsdGVkX1+TbgLI+IcXcsZG9Lj8FTuojmuiMQHuKS4=",
        "cpf": "U2FsdGVkX1/CcHDyH/UaddKgigZomTThj5sDQIyvZGM="
      }, {
        "num_cand": "U2FsdGVkX1+MUnjXQiNLvYSpUtqYE1qYNHRKPMibyLk=",
        "cpf": "U2FsdGVkX1/n74UfZGVI1Hljl5V/T+uZ5q2pZdG26Ls="
      }, {
        "num_cand": "U2FsdGVkX1+TSLnmFzJocwPfxYHpCrldVSPTP5edgxk=",
        "cpf": "U2FsdGVkX1/Jq907I/ibZoqOpoBNSacSqBYfwAPF89c="
      }, {
        "num_cand": "U2FsdGVkX18h9f40JJL4j0rRf7OTRF0PrYMvRnR6jHI=",
        "cpf": "U2FsdGVkX1/ueWo7p2OMEda6EL9nnYrncVdEKt/1ykw="
      }, {
        "num_cand": "U2FsdGVkX1/5F9YyuJZqHoehxrC0rG8xJ17wOrEIV/U=",
        "cpf": "U2FsdGVkX1+Of7Br34nnvc5QvuPZjAZXx6jeWUo82ww="
      }, {
        "num_cand": "U2FsdGVkX18SdNrcO5uF0aaTPJhOR0wz5bLOpa5UZ7E=",
        "cpf": "U2FsdGVkX189KKs7nsYzOXHOmv0aryiqSjI0R+qtYjA="
      }, {
        "num_cand": "U2FsdGVkX1837ry8W5TQtKL9jaE6nrBN3ea8C2KvRgk=",
        "cpf": "U2FsdGVkX1+EzId/OD9d61RvoNlu1Kq5J7oxb3z0c0I="
      }, {
        "num_cand": "U2FsdGVkX18EYIYUwhMBZ4A8pl7+IjyV61oSA57PZW0=",
        "cpf": "U2FsdGVkX1/zu1OuYCJHCv6OfRhVR4iRDwnYN8x51Xg="
      }, {
        "num_cand": "U2FsdGVkX1/SZNu9Ha0GJAbuh/OhKNMOaM0b1IjSa3k=",
        "cpf": "U2FsdGVkX19mUuSqEpu5nxzPtrAeRF2l5+NIqh0gruQ="
      }, {
        "num_cand": "U2FsdGVkX19AfOlsTyCk9sutwcyApJ72ALgie2JdQbw=",
        "cpf": "U2FsdGVkX1+afRjSx8+nVqeexVczN2c7J2aEUsHuyOU="
      }, {
        "num_cand": "U2FsdGVkX1/75x+Tq8nW71o40eLSsKdIgP7JaX7IU8o=",
        "cpf": "U2FsdGVkX1+eMdbOfvH9ucDhE+/KJ42109z/fuW3g5k="
      }, {
        "num_cand": "U2FsdGVkX18YJ9P8p0F62TxwBhN2pNqKhF98+Fg77E8=",
        "cpf": "U2FsdGVkX1996gBDCm5EgjwCIOh1iChEzS+Dn2HeqwY="
      }, {
        "num_cand": "U2FsdGVkX184z7lDhluOr5lmRGZuxcVVFjV4QtD7/v4=",
        "cpf": "U2FsdGVkX19LLXo4b9eqmlvkE66NpnKyDeQ5YwZnbL4="
      }, {
        "num_cand": "U2FsdGVkX18KPQz5hW+Uz5mwuykVAmrrFsJw5NuPgUM=",
        "cpf": "U2FsdGVkX18n5zxMtssfxe6PLsn5Xdt+GgBurjV6un0="
      }, {
        "num_cand": "U2FsdGVkX1/AnGyxQ9tg1My2JHEj9qT6ahaNEGXQ/PQ=",
        "cpf": "U2FsdGVkX1/uRJz8Y+opmJe3ILXHIc7244DvWf47MFw="
      }, {
        "num_cand": "U2FsdGVkX1+0Gq6tCfzmHrQocCfOtliAqpBxKt8rElA=",
        "cpf": "U2FsdGVkX190v6Pmd/SlHOA/FHFybLo0lEblXF2lZQA="
      }, {
        "num_cand": "U2FsdGVkX1+iYQBw/c4BZsTI7TKw7yqIdulJ+B8E5Dw=",
        "cpf": "U2FsdGVkX1+IEDwm72w6yADc2pkiNfuB9k8iSDswRGQ="
      }, {
        "num_cand": "U2FsdGVkX18lg5w5SssHgMzKeoqeHn2guLjlQqes7t4=",
        "cpf": "U2FsdGVkX1+qJqB8bCsyhRpB0Q7Ih2ffbBi97UlO73o="
      }, {
        "num_cand": "U2FsdGVkX1+E/eIJiZiumoocu26l8e3579pEQ59h8VM=",
        "cpf": "U2FsdGVkX1/QsNPJytZ2TM5w8fhGlvkCS4QegURnCdQ="
      }, {
        "num_cand": "U2FsdGVkX1/jTEOTXPD3Ee0qeNxtkSltTnV444FB4Ko=",
        "cpf": "U2FsdGVkX1/JaksGHcOOavOKNjiBLKtmk4X5YI2JeTY="
      }, {
        "num_cand": "U2FsdGVkX1+iXKAbUZuy5fyqPpIakAHiRc2DyAnWOBg=",
        "cpf": "U2FsdGVkX18jSsDBcS3C+Tx+hdMQb0/I/xVOGYCcZgo="
      }, {
        "num_cand": "U2FsdGVkX19cGIIDhs+4Cjyj4W4LqfnPw5Kpt9etdjA=",
        "cpf": "U2FsdGVkX18rDEAoIVZvZ45S3LWw2JQyfAbsRqpD0zw="
      }, {
        "num_cand": "U2FsdGVkX19BGy1+6LW4E8he0Qy4ZLeJ9v1s8Z1rLBE=",
        "cpf": "U2FsdGVkX1+y5P2JyzPnDjjuTrAoHGhXCZvq5clphoA="
      }, {
        "num_cand": "U2FsdGVkX19Nn77ZHXBYjnS1DZ1Mp5w2YxoS4DBM28o=",
        "cpf": "U2FsdGVkX1+T1U4KPMT/HF1E1NdGHiJyVTrz5OtLd10="
      }, {
        "num_cand": "U2FsdGVkX1+WssYAjU52qV6JgKpBdoYJOQv34iZ+FXE=",
        "cpf": "U2FsdGVkX1/tZYhWTBsDAqR6S8rMF3LraIf++SpYJKk="
      }, {
        "num_cand": "U2FsdGVkX18Di+mupuhKXarpeanT7xwm23PjWIvkMlI=",
        "cpf": "U2FsdGVkX1+6d3htk4iX5ZwGAHjwhgkjz0FP55EtpgY="
      }, {
        "num_cand": "U2FsdGVkX1+PDxjyJvNCvTrdkbUfjBXqjv7yvtmqCyY=",
        "cpf": "U2FsdGVkX18cB0thHyZQ/cAiVENStlOobXA0GFkmYww="
      }, {
        "num_cand": "U2FsdGVkX19KQKUIKoA29rt6JTizg9izGbkZ+FHs8Yg=",
        "cpf": "U2FsdGVkX1+9eTenS/FqrHIprnGEaeNHELJlYpdxU1Y="
      }, {
        "num_cand": "U2FsdGVkX1/TxscTQxc8ueKZpJqUr9yoR2DlB2DW+EM=",
        "cpf": "U2FsdGVkX18miOB+KDOlyCM/wRPXBii4elpecnj6pjQ="
      }, {
        "num_cand": "U2FsdGVkX1+sR6UYaJ4bdtECP5Pl8cr/aPnhZHnqPZg=",
        "cpf": "U2FsdGVkX18Q9w9nPUlEovt9wcoXX83XN0Sv4ukq7cY="
      }, {
        "num_cand": "U2FsdGVkX1+wsvMRr8ujmn2YQPzZAVjOBJQlHKmh9gk=",
        "cpf": "U2FsdGVkX1+P4Ejq7GY7Wc8vzCWOoMi+b3rCtcprHo8="
      }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2202/2202_rec_titi/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
